import React, { useState } from 'react';
import { Clothing, ItemPricing } from '../..';
import { SelectInput } from '../../../Components';
import './Style.css';
const Index = () => {
    const [product, setProduct] = useState('null');

    return (
        <div className="merch_pricing">
            <div className="merch_pricing_calculator">
                <div className="home_head">
                    <div style={{ display: 'flex', flexDirection: 'column' }}>
                        <h2 className="home_heading">Pricing Calculator for Products</h2>
                        <p
                            style={{
                                fontSize: '0.8rem',
                                color: '#00000070',
                                fontWeight: 'bold',
                            }}
                        >
                            * GST 5% Including in all prices
                        </p>
                    </div>
                </div>
                <div className="merch_pricing_calculator_body">
                    <div className="merch_pricing_calculator_product_type">
                        <SelectInput
                            label="Product Type"
                            outlined={true}
                            value={product}
                            changeHandler={(e) => {
                                setProduct(e.target.value);
                            }}
                            options={[
                                { name: 'Select a Product', value: 'null' },
                                { name: 'T-Shirt', value: 'T-Shirt' },
                                { name: 'Hoodie', value: 'Hoodie' },
                                { name: 'White Coffee Mug', value: 'White Coffee Mug' },
                                { name: 'Black Patch Coffee Mug', value: 'Black Patch Coffee Mug' },
                                { name: 'Magic Mug', value: 'Magic Mug' },
                                { name: 'Tea Mug', value: 'Tea Mug' },
                                { name: 'Glow In Dark Mug', value: 'Glow In Dark Mug' },
                                { name: 'Beer Mug', value: 'Beer Mug' },
                                { name: 'Sipper Bottle', value: 'Sipper Bottle' },
                                { name: 'Tile', value: 'Tile' },
                                { name: 'Fridge Magnet', value: 'Fridge Magnet' },
                                { name: 'Heart Puzzle', value: 'Heart Puzzle' },
                                { name: 'Door Hanger', value: 'Door Hanger' },
                                { name: 'Coaster', value: 'Coaster' },
                                { name: 'Mouse Pad', value: 'Mouse Pad' },
                                { name: 'Poster', value: 'Poster' },
                            ]}
                        />
                    </div>
                    <div className="merch_pricing_calculator_product_details">
                        {product === 'T-Shirt' || product === 'Hoodie' ? (
                            <Clothing deliverycost={55} product={product} />
                        ) : product !== 'null' ? (
                            <ItemPricing deliverycost={55} colorInside={product.endsWith('Mug')} product={product} />
                        ) : (
                            ''
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Index;
